import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["google", "facebook", "telegram", "apple"]
  static values = {
    googleClientId: String,
    googleUrl: String,
    facebookAppId: String,
    facebookUrl: String,
    telegramBotUsername: String,
    telegramUrl: String,
    xUrl: String,
    appleClientId: String,
    appleUrl: String,
    appleRedirectUri: String,
    locale: { type: String, default: "uk" }
  }

  connect() {
    if (this.hasGoogleTarget && this.googleClientIdValue) this.loadGoogle()
    if (this.hasFacebookTarget && this.facebookAppIdValue) this.loadFacebook()
    if (this.hasTelegramTarget && this.telegramBotUsernameValue) this.loadTelegram()
    if (this.hasAppleTarget && this.appleClientIdValue) this.loadApple()
  }

  loadGoogle() {
    this.loadScript("google-identity-services", "https://accounts.google.com/gsi/client").then(() => {
      window.google.accounts.id.initialize({
        client_id: this.googleClientIdValue,
        callback: (response) => this.submit(this.googleUrlValue, { credential: response.credential })
      })
      window.google.accounts.id.renderButton(this.googleTarget, { type: "standard", theme: "filled_blue", size: "large", text: "signin_with", locale: this.localeValue, width: 150 })
    })
  }

  loadFacebook() {
    this.loadScript("facebook-jssdk", "https://connect.facebook.net/en_US/sdk.js").then(() => {
      window.FB.init({ appId: this.facebookAppIdValue, cookie: true, xfbml: false, version: "v20.0" })
      this.facebookTarget.addEventListener("click", () => window.FB.login((response) => {
        if (response.authResponse) this.submit(this.facebookUrlValue, { access_token: response.authResponse.accessToken })
      }, { scope: "email" }))
    })
  }

  loadTelegram() {
    window.kramTelegramAuth = (user) => this.submit(this.telegramUrlValue, user)
    this.loadScript("telegram-login-widget", "https://telegram.org/js/telegram-widget.js?22", (script) => {
      script.dataset.telegramLogin = this.telegramBotUsernameValue
      script.dataset.size = "medium"
      script.dataset.userpic = "false"
      script.dataset.onauth = "kramTelegramAuth(user)"
      this.telegramTarget.appendChild(script)
    })
  }

  loadApple() {
    this.loadScript("appleid-auth", "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js").then(() => {
      window.AppleID.auth.init({ clientId: this.appleClientIdValue, scope: "name email", redirectURI: this.appleRedirectUriValue, usePopup: true })
      this.appleTarget.addEventListener("click", () => window.AppleID.auth.signIn().then((response) => {
        this.submit(this.appleUrlValue, { id_token: response.authorization.id_token })
      }))
    })
  }

  submit(url, values) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(url, { method: "POST", headers: { "X-CSRF-Token": token, Accept: "text/html" }, body: new URLSearchParams(values), credentials: "same-origin" })
      .then((response) => { if (response.redirected) window.location.assign(response.url); else if (!response.ok) window.location.reload() })
  }

  loadScript(id, src, configure = null) {
    const existing = document.getElementById(id)
    if (existing && (id === "google-identity-services" ? window.google?.accounts?.id : id === "appleid-auth" ? window.AppleID : window.FB)) return Promise.resolve()
    if (existing) return new Promise((resolve) => existing.addEventListener("load", resolve, { once: true }))

    return new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.id = id
      script.src = src
      script.async = true
      script.defer = true
      configure?.(script)
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
  }
}
